module.exports = __webpack_public_path__ + "img/image-to-library.af6f1538.png";